import { IConditionalFilterNode } from '../../helpers/conditional-nodes.helpers';
import {
  ElementPropertyName,
  IFactoryProperty,
  ElementPropertyType,
} from '../../models/element-property.model';
import { IFactoryProductElement } from '../../models/factory-element.model';
import { ProductID } from '../../models/product.model';
import { ElementKind } from '../../models/project.model';

export const reusedContentProductId = 'boverket_sv-SE_6000000174';

export const reusedContentFactoryElement: IFactoryProductElement =
  Object.freeze({
    kind: ElementKind.Product,
    product_id: reusedContentProductId,
    count: `(${ElementPropertyName.ReusedContent}) * mass`,
    unit: 'kg',
    hide_product_without_count: true,
  });

export const reusedContentProperty: Readonly<IFactoryProperty> = Object.freeze({
  name: ElementPropertyName.ReusedContent,
  type: ElementPropertyType.Expression,
  unit: '%',
  min: 0,
  max: 100,
  fallbackCount: 0,
});

const conditions: IConditionalFilterNode<ProductID>['conditions'] = {
  [ElementPropertyName.ReusedContent]: '>0',
};

export const conditionalReusedContentProductId: IConditionalFilterNode<ProductID> =
  {
    conditions,
    nodes: [reusedContentProductId],
  };

export const conditionalReusedContentFactoryElement: IConditionalFilterNode<IFactoryProductElement> =
  {
    conditions,
    nodes: [reusedContentFactoryElement],
  };
